/* Andy Cooks – recipe index loader + header type-ahead search (shared by the recipes hub) */
(function () {
  'use strict';
  var acT = function (k, f, v) { var s = (window.AC_I18N && window.AC_I18N[k]) || f; if (v) { for (var n in v) { s = s.split('__' + n + '__').join(v[n]); } } return s; };
  var KEY = 'acIdx:v4', TTL = 6 * 3600 * 1000;
  var pv = (location.search.match(/preview_theme_id=\d+/) || [''])[0];
  function url(p, view) { return '/blogs/recipes?view=' + view + '&page=' + p + (pv ? '&' + pv : ''); }

  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[’']/g, ''); }
  function prep(list) {
    list.forEach(function (r) {
      r.nt = norm(r.t);
      r.ng = norm((r.g || []).join(' '));
      r.tl = (r.g || []).map(function (t) { return t.toLowerCase(); });
    });
    return list;
  }

  var promise = null;
  function getAll(view) {
    return fetch(url(1, view), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (first) {
      var rest = [];
      for (var p = 2; p <= (first.pages || 1); p++) rest.push(fetch(url(p, view), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return { items: [] }; }));
      return Promise.all(rest).then(function (pages) { return first.items.concat.apply(first.items, pages.map(function (x) { return x.items || []; })); });
    });
  }
  /* join: blog posts (title, image, tags, rating, date) + Recipes by Andy entries (time, video, extra tags); only posts with an entry are kept */
  /* reviews feed: metaobject pages use Shopify's own page_xxxxxxxx parameter - read it from page 1's "next" link */
  function getReviews() {
    return fetch(url(1, 'acrev'), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (first) {
      var pages = first.pages || 1, m = String(first.next || '').match(/[?&](page_[0-9a-f]+)=/), key = m ? m[1] : 'page', rest = [];
      for (var p = 2; p <= pages; p++) rest.push(fetch('/blogs/recipes?view=acrev&' + key + '=' + p + (pv ? '&' + pv : ''), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return { items: [] }; }));
      return Promise.all(rest).then(function (ps) { return first.items.concat.apply(first.items, ps.map(function (x) { return x.items || []; })); });
    });
  }
  /* ratings: Recipes by Andy reviews (approved, rated, not replies) added up per recipe id */
  function tally(revs) {
    var t = {};
    (revs || []).forEach(function (x) { if (!x || x.length < 2) return; var k = String(x[0]), v = +x[1]; if (!(v > 0)) return; (t[k] = t[k] || [0, 0]); t[k][0] += v; t[k][1]++; });
    return t;
  }
  function join(arts, mos, revs) {
    var mo = {}; mos.forEach(function (m) { mo[m.h] = m; });
    var rt = revs && revs.length ? tally(revs) : null;   /* no review data at all -> keep the old ratings rather than show none */
    var seen = {}, out = [];
    arts.forEach(function (a) {
      var m = mo[a.h]; if (!m || seen[a.h]) return; seen[a.h] = 1;
      var tags = (a.g || []).slice();
      (m.g || []).forEach(function (t) { if (tags.indexOf(t) < 0) tags.push(t); });
      var rv = a.rv || 0, rc = a.rc || 0;
      if (rt) { var tt = rt[String(m.id || '')]; rv = tt ? Math.round(tt[0] / tt[1] * 10) / 10 : 0; rc = tt ? tt[1] : 0; }
      out.push({ h: a.h, id: m.id || '', t: a.t || m.t, u: a.u, i: a.i, g: tags, m: m.m || 0, v: m.v || 0, rv: rv, rc: rc, d: a.d || 0 });
    });
    return out;
  }
  function load() {
    if (promise) return promise;
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && Date.now() - c.at < TTL && c.items && c.items.length) { promise = Promise.resolve(prep(c.items)); return promise; }
    } catch (e) {}
    /* if the reviews feed ever fails, fall back to the old ratings rather than show none */
    promise = Promise.all([getAll('acindex'), getAll('acmo'), getReviews().catch(function () { return null; })]).then(function (res) {
      var out = join(res[0], res[1], res[2]);
      try { sessionStorage.setItem(KEY, JSON.stringify({ at: Date.now(), items: out })); } catch (e) {}
      return prep(out);
    }).catch(function (e) { promise = null; throw e; });
    return promise;
  }

  function tokens(q) {
    return norm(q).split(/[^a-z0-9]+/).filter(Boolean).map(function (t) { return t.length > 3 && /s$/.test(t) && !/ss$/.test(t) ? t.slice(0, -1) : t; });
  }
  function search(list, q, limit) {
    var qn = norm(q).trim(), toks = tokens(q);
    if (!toks.length) return [];
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var r = list[i], hay = r.nt + ' ' + r.ng, ok = true, s = 0;
      for (var k = 0; k < toks.length; k++) {
        var t = toks[k];
        if (hay.indexOf(t) < 0) { ok = false; break; }
        if (r.nt.indexOf(t) >= 0) s += 20;
        if ((' ' + r.nt).indexOf(' ' + t) >= 0) s += 15;
        if ((' ' + r.ng).indexOf(' ' + t) >= 0) s += 6;
      }
      if (!ok) continue;
      if (r.nt.indexOf(qn) === 0) s += 60; else if (r.nt.indexOf(qn) > 0) s += 25;
      s += Math.min(r.rc || 0, 25) * 0.6 + (r.rv || 0);
      out.push([s, r]);
    }
    out.sort(function (a, b) { return b[0] - a[0] || b[1].d - a[1].d; });
    return out.slice(0, limit || 8).map(function (x) { return x[1]; });
  }

  /* phrases ("I'm very hungry, I like steak and potatoes"): ignore the filler words and rank recipes by how many
     of the meaningful words they match, so the type-ahead still shows the best few while the AI works on Enter */
  var STOP = {};
  ('i im id ive me my we our us you your a an the and or but with without for of to in on at by from some something anything any ' +
   'want wanna would like likes love fancy feel feeling very really so too hungry starving craving crave cravings make cook cooking ' +
   'recipe recipes dish dishes food meal meals tonight today please give show find need good nice tasty delicious yummy can could ' +
   'get eat eating have has had is are am be that this it its what whats idea ideas people person serve serves family kids').split(' ').forEach(function (w) { STOP[w] = 1; });
  function keyTokens(q) {
    return tokens(q).map(function (t) { return t.replace(/oe$/, 'o'); }).filter(function (t) { return t.length > 2 && !STOP[t] && !/^\d+$/.test(t); });
  }
  function relaxed(list, q, limit) {
    var toks = keyTokens(q);
    if (!toks.length) return [];
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var r = list[i], nt = ' ' + r.nt, hay = nt + ' ' + r.ng, hit = 0, s = 0;
      for (var k = 0; k < toks.length; k++) {
        var t = ' ' + toks[k];
        if (hay.indexOf(t) < 0) continue;
        hit++; s += nt.indexOf(t) >= 0 ? 20 : 6;
      }
      if (!hit) continue;
      s += Math.min(r.rc || 0, 25) * 0.6 + (r.rv || 0);
      out.push([hit, s, r]);
    }
    out.sort(function (a, b) { return b[0] - a[0] || b[1] - a[1] || b[2].d - a[2].d; });
    return out.slice(0, limit || 5).map(function (x) { return x[2]; });
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function mins(m) { if (!m) return ''; var h = Math.floor(m / 60), n = m % 60; return h ? (n ? acT('ac.js.search.time_hr_min', '__h__ hr __m__ min', { h: h, m: n }) : acT('ac.js.search.time_hr', '__h__ hr', { h: h })) : acT('ac.js.search.time_min', '__m__ min', { m: n }); }
  function stars(r) {
    if (!r.rc) return '';
    var pct = Math.max(0, Math.min(100, (r.rv / 5) * 100)), s = '';
    for (var i = 0; i < 5; i++) s += '<svg viewBox="0 0 24 24"><path d="M12 2.2l2.9 6.3 6.9.7-5.2 4.6 1.5 6.8L12 17.1l-6.1 3.5 1.5-6.8-5.2-4.6 6.9-.7z"/></svg>';
    return '<span class="acs-stars" aria-label="' + acT('ac.js.search.rated_out_of_5', 'Rated __rating__ out of 5', { rating: (+r.rv).toFixed(1) }) + '"><span class="acs-stars__row">' + s + '</span><span class="acs-stars__fill" style="width:' + pct + '%"><span class="acs-stars__row">' + s + '</span></span></span><span class="acs-count">(' + r.rc + ')</span>';
  }
  function highlight(title, q) {
    var toks = tokens(q), t = esc(title);
    toks.forEach(function (k) { if (k.length < 2) return; t = t.replace(new RegExp('(' + k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>'); });
    return t;
  }
  function img(src, w) { return src ? src.replace(/width=\d+/, 'width=' + w) : ''; }

  window.ACIndex = { load: load, search: search, norm: norm, esc: esc, mins: mins, stars: stars, img: img };

  /* ---------- server-drawn ratings (search results page, home "latest recipe"): refresh from the Recipes by Andy reviews ---------- */
  function hydrateRatings() {
    var slots = document.querySelectorAll('[data-ac-rate], [data-ac-rate-latest]');
    if (!slots.length) return;
    load().then(function (list) {
      var by = {}; list.forEach(function (r) { by[r.h] = r; });
      [].forEach.call(document.querySelectorAll('[data-ac-rate]'), function (el) {
        var r = by[el.getAttribute('data-ac-rate')]; if (!r) return;
        el.innerHTML = r.rc ? '<span class="rh-card__rate">' + stars(r) + '</span>' : '';
      });
      [].forEach.call(document.querySelectorAll('[data-ac-rate-latest]'), function (el) {
        var r = by[el.getAttribute('data-ac-rate-latest')]; if (!r) return;
        if (!r.rc) { el.hidden = true; return; }
        el.querySelector('b').textContent = (+r.rv).toFixed(1);
        el.querySelector('span').textContent = '(' + r.rc + ')';
        el.hidden = false;
      });
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrateRatings); else hydrateRatings();

  /* ---------- type-ahead: header, home page hero, footer and search page bars ---------- */
  var SEARCH_BARS = ['AcHeaderSearch', 'Ach2Search', 'AcxFootSearch', 'AcsrQ'];
  var UP_BARS = { AcxFootSearch: 1 };   /* the footer bar opens its list upwards */
  function initHeader(input) {
    if (!input || input.dataset.acsReady) return;
    var form = input.closest('form'); if (!form) return;
    input.dataset.acsReady = '1';
    var wrap = form.parentNode, uid = 'AcSearchDrop' + (input.id === 'AcHeaderSearch' ? '' : '-' + input.id), opt = uid + '-o';
    wrap.classList.add('acs-wrap');
    var box = document.createElement('div');
    box.className = 'acs-drop'; box.id = uid; box.hidden = true; box.setAttribute('role', 'listbox');
    /* the header list sits under its bar; the other bars live inside sections that clip their contents and have their
       own text styles, so their list floats above the page (fixed position, placed under or above the bar) */
    var floating = input.id !== 'AcHeaderSearch', up = !!UP_BARS[input.id];
    if (floating) { box.classList.add('acs-drop--float'); if (up) box.classList.add('acs-drop--up'); document.body.appendChild(box); }
    else wrap.appendChild(box);
    function place() {
      if (!floating || box.hidden) return;
      var r = form.getBoundingClientRect(), vw = document.documentElement.clientWidth;
      var w = Math.min(vw - 24, Math.max(r.width, vw < 900 ? 0 : 520)), l = r.left + r.width / 2 - w / 2;
      l = Math.max(12, Math.min(l, vw - 12 - w));
      box.style.left = l + 'px'; box.style.width = w + 'px'; box.style.right = 'auto';
      var hd = document.getElementById('SiteHeader'), hb = hd ? Math.max(0, hd.getBoundingClientRect().bottom) : 0;   /* stay below the sticky header */
      if (up) { box.style.top = 'auto'; box.style.bottom = (window.innerHeight - r.top + 10) + 'px'; box.style.maxHeight = Math.max(160, r.top - hb - 20) + 'px'; }
      else { box.style.bottom = 'auto'; box.style.top = (r.bottom + 10) + 'px'; box.style.maxHeight = Math.max(200, window.innerHeight - r.bottom - 20) + 'px'; }
    }
    if (floating) { window.addEventListener('scroll', place, { passive: true }); window.addEventListener('resize', place); }
    input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list'); input.setAttribute('aria-controls', uid); input.setAttribute('aria-expanded', 'false');
    var POPULAR = [acT('ac.js.search.popular_chicken', 'Chicken'), acT('ac.js.search.popular_pasta', 'Pasta'), acT('ac.js.search.popular_quick', 'Quick'), acT('ac.js.search.popular_beef', 'Beef'), acT('ac.js.search.popular_curry', 'Curry'), acT('ac.js.search.popular_dessert', 'Dessert'), acT('ac.js.search.popular_burger', 'Burger'), acT('ac.js.search.popular_slow_cooked', 'Slow cooked')];
    var active = -1, results = [], timer = null, list = null;

    function open() { box.hidden = false; input.setAttribute('aria-expanded', 'true'); place(); }
    function close() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
    function seeAll(q) { return '/search?type=article&options%5Bprefix%5D=last&q=' + encodeURIComponent(q); }

    function renderEmpty() {
      box.innerHTML = '<p class="acs-label">' + acT('ac.js.search.popular', 'Popular right now') + '</p><div class="acs-chips">' + POPULAR.map(function (p) { return '<button type="button" data-acs-q="' + esc(p) + '">' + esc(p) + '</button>'; }).join('') + '</div>';
      results = []; open();
    }
    function render(q) {
      if (!q.trim()) return renderEmpty();
      if (!list) { box.innerHTML = '<p class="acs-loading"><span></span>' + acT('ac.js.search.finding', 'Finding recipes…') + '</p>'; open(); return; }
      /* a phrase (2+ words) goes to the smart search (assets/ac-ai-search.js) on Enter / "Show all matches" */
      var phrase = !!(window.ACAISearch && input.form && q.trim().split(/\s+/).length >= 2), hq = q;
      results = search(list, q, phrase ? 5 : 7);
      /* phrases: top up the exact matches with the best partial matches (ignoring filler words like "and", "I like") */
      if (phrase && results.length < 5) {
        var seenR = {}; results.forEach(function (r) { seenR[r.h] = 1; });
        relaxed(list, q, 10).forEach(function (r) { if (results.length < 5 && !seenR[r.h]) { seenR[r.h] = 1; results.push(r); } });
        if (keyTokens(q).length) hq = keyTokens(q).join(' ');
      }
      if (!results.length) {
        if (phrase) {
          box.innerHTML = '<p class="acs-none">' + acT('ac.js.search.ai_hint', 'Press enter and we\'ll find recipes to match.') + '</p><button type="button" class="acs-all" data-acs-ai>' + acT('ac.js.search.ai_find', 'Find recipes') + ' <span aria-hidden="true">&rarr;</span></button>';
          open(); return;
        }
        box.innerHTML = '<p class="acs-none">' + acT('ac.js.search.no_match', 'No recipes match “__q__” yet.', { q: esc(q) }) + '</p><a class="acs-all" href="' + seeAll(q) + '">' + acT('ac.js.search.search_site', 'Search the whole site') + ' <span aria-hidden="true">&rarr;</span></a>';
        open(); return;
      }
      box.innerHTML = '<p class="acs-label">' + acT('ac.js.search.recipes', 'Recipes') + '</p><ul class="acs-list">' + results.map(function (r, i) {
        return '<li role="option" id="' + opt + i + '"><a href="' + esc(r.u) + '" class="acs-item" data-i="' + i + '">' +
          '<span class="acs-thumb">' + (r.i ? '<img src="' + esc(img(r.i, 160)) + '" alt="" loading="lazy" width="56" height="56">' : '') + '</span>' +
          '<span class="acs-txt"><span class="acs-title">' + highlight(r.t, hq) + '</span><span class="acs-meta">' +
          (r.m ? '<span>' + mins(r.m) + '</span>' : '') + (r.rc ? '<span class="acs-rate">' + stars(r) + '</span>' : '') + '</span></span></a></li>';
      }).join('') + '</ul>' + (phrase
        ? '<button type="button" class="acs-all" data-acs-ai>' + acT('ac.js.search.show_all_matches', 'Show all matches') + ' <span aria-hidden="true">&rarr;</span></button>'
        : '<a class="acs-all" href="' + seeAll(q) + '">' + acT('ac.js.search.see_all', 'See all results for “__q__”', { q: esc(q) }) + ' <span aria-hidden="true">&rarr;</span></a>');
      active = -1; open();
    }
    function setActive(i) {
      var items = box.querySelectorAll('.acs-item');
      if (!items.length) return;
      active = (i + items.length) % items.length;
      items.forEach(function (el, k) { el.classList.toggle('is-active', k === active); });
      input.setAttribute('aria-activedescendant', opt + active);
      items[active].scrollIntoView({ block: 'nearest' });
    }
    function warm() { if (list) return; load().then(function (l) { list = l; if (!box.hidden) render(input.value); }).catch(function () {}); }

    input.addEventListener('focus', function () { warm(); render(input.value); });
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { render(input.value); }, 60); });
    input.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && active >= 0 && results[active]) { e.preventDefault(); location.href = results[active].u; }
    });
    box.addEventListener('mousedown', function (e) { e.preventDefault(); });
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-acs-ai]')) { close(); if (form.requestSubmit) form.requestSubmit(); else form.submit(); return; }
      var b = e.target.closest('[data-acs-q]');
      if (b) { input.value = b.getAttribute('data-acs-q'); input.focus(); render(input.value); }
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target) && !box.contains(e.target)) close(); });
    input.addEventListener('blur', function () { setTimeout(function () { if (document.activeElement !== input) close(); }, 150); });
    if ('requestIdleCallback' in window) requestIdleCallback(function () { if (/\/blogs\/recipes/.test(location.pathname)) warm(); });
  }
  /* search results page: hide any old RecipeKit-only posts (Liquid can only check ~20 entries per page, so tidy up here) */
  function tidySearch() {
    if (!/^\/search/.test(location.pathname)) return;
    load().then(function (l) {
      var ok = {}; l.forEach(function (r) { ok[r.u.split('/').pop()] = 1; });
      document.querySelectorAll('.grid__item a[href*="/blogs/recipes/"]').forEach(function (el) {
        var h = el.getAttribute('href').split('?')[0].split('#')[0].split('/').pop();
        if (!ok[h]) { var it = el.closest('.grid__item'); if (it) it.style.display = 'none'; }
      });
    }).catch(function () {});
  }
  function init() {
    if (!document.getElementById('acs-up-css')) {
      var st = document.createElement('style'); st.id = 'acs-up-css';
      st.textContent = '.acs-drop.acs-drop--float{position:fixed;transform:none;z-index:1000;overflow-y:auto}.acs-drop--up{box-shadow:0 -18px 40px rgba(0,0,0,.16)}';
      document.head.appendChild(st);
    }
    SEARCH_BARS.forEach(function (id) { initHeader(document.getElementById(id)); });
    tidySearch();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
